import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {




    //********************************************************************| Authintecations |***********************************************************

    login(bodyObjeect) {
        return axios.post(`/Security/login`, bodyObjeect);
    },

    IsLoggedin() {
        return axios.get(`/Security/IsLoggedin`);
    },

    Logout() {
        return axios.post(`/Security/Logout`);
    },








    // ********************************| Start Dictionaries |******************************


    // PaymentMethods
    GetPaymentMethods(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PaymentMethods/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPaymentMethods() {
        return axios.get(`api/admin/Dictionaries/PaymentMethods/GetAll`);
    },

    AddPaymentMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentMethods/Add`, bodyObject);
    },

    EditPaymentMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentMethods/Edit`, bodyObject);
    },

    DeletePaymentMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentMethods/Delete`);
    },

    ChangeStatusPaymentMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentMethods/ChangeStatus`);
    },







    // FinancialsWithdrawing
    GetFinancialsWithdrawing(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/FinancialsWithdrawing/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllFinancialsWithdrawing() {
        return axios.get(`api/admin/Dictionaries/FinancialsWithdrawing/GetAll`);
    },

    AddFinancialsWithdrawing(bodyObject) {
        return axios.post(`api/admin/Dictionaries/FinancialsWithdrawing/Add`, bodyObject);
    },

    EditFinancialsWithdrawing(bodyObject) {
        return axios.post(`api/admin/Dictionaries/FinancialsWithdrawing/Edit`, bodyObject);
    },

    DeleteFinancialsWithdrawing(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/FinancialsWithdrawing/Delete`);
    },

    ChangeStatusFinancialsWithdrawing(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/FinancialsWithdrawing/ChangeStatus`);
    },
















    // Subjects
    GetSubjects(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Subjects/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllSubjects(AcademicSpecializationsId) {
        return axios.get(`api/admin/Dictionaries/Subjects/GetAll?AcademicSpecializationsId=${AcademicSpecializationsId}`);
    },

    AddSubjects(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Subjects/Add`, bodyObject);
    },

    EditSubjects(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Subjects/Edit`, bodyObject);
    },

    DeleteSubjects(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Subjects/Delete`);
    },

    ChangeStatusSubjects(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Subjects/ChangeStatus`);
    },

    // WelcomePanels
    GetWelcomePanels(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/WelcomePanels/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AddWelcomePanels(bodyObject) {
        return axios.post(`api/admin/Dictionaries/WelcomePanels/Add`, bodyObject);
    },

    EditWelcomePanels(bodyObject) {
        return axios.post(`api/admin/Dictionaries/WelcomePanels/Edit`, bodyObject);
    },

    DeleteWelcomePanels(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/WelcomePanels/Delete`);
    },

    ChangeStatusWelcomePanels(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/WelcomePanels/ChangeStatus`);
    },

    // Reels
    GetReels(pageNo, pageSize, Search, StatusFilter) {
        const status = StatusFilter === undefined || StatusFilter === null ? 0 : StatusFilter;
        return axios.get(`api/admin/Reels/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}&StatusFilter=${status}`);
    },

    ApproveReel(Id) {
        return axios.post(`api/admin/Reels/${Id}/Approve`);
    },

    RejectReel(Id, bodyObject) {
        return axios.post(`api/admin/Reels/${Id}/Reject`, bodyObject);
    },

    DeleteReel(Id) {
        return axios.post(`api/admin/Reels/${Id}/Delete`);
    },

    // Stories
    GetStories(pageNo, pageSize, Search, StatusFilter) {
        const status = StatusFilter === undefined || StatusFilter === null ? 0 : StatusFilter;
        return axios.get(`api/admin/Stories/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}&StatusFilter=${status}`);
    },
    ApproveStory(Id) {
        return axios.post(`api/admin/Stories/${Id}/Approve`);
    },
    RejectStory(Id, bodyObject) {
        return axios.post(`api/admin/Stories/${Id}/Reject`, bodyObject);
    },
    DeleteStory(Id) {
        return axios.post(`api/admin/Stories/${Id}/Delete`);
    },

    // CommunityPosts
    GetCommunityPosts(pageNo, pageSize, Search, StatusFilter, PostType) {
        const status = StatusFilter === undefined || StatusFilter === null ? 0 : StatusFilter;
        const postType = PostType === undefined || PostType === null ? 0 : PostType;
        return axios.get(`api/admin/CommunityPosts/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}&StatusFilter=${status}&PostType=${postType}`);
    },
    ApproveCommunityPost(Id) {
        return axios.post(`api/admin/CommunityPosts/${Id}/Approve`);
    },
    RejectCommunityPost(Id, bodyObject) {
        return axios.post(`api/admin/CommunityPosts/${Id}/Reject`, bodyObject);
    },
    DeleteCommunityPost(Id) {
        return axios.post(`api/admin/CommunityPosts/${Id}/Delete`);
    },





    // AcademicLevels
    GetAcademicLevels(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/AcademicLevels/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllAcademicLevels() {
        return axios.get(`api/admin/Dictionaries/AcademicLevels/GetAll`);
    },

    AddAcademicLevels(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicLevels/Add`, bodyObject);
    },

    EditAcademicLevels(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicLevels/Edit`, bodyObject);
    },

    DeleteAcademicLevels(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicLevels/Delete`);
    },

    ChangeStatusAcademicLevels(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicLevels/ChangeStatus`);
    },



    // Cities
    GetCities(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Cities/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllCities() {
        return axios.get(`api/admin/Dictionaries/Cities/GetAll`);
    },

    AddCities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Cities/Add`, bodyObject);
    },

    EditCities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Cities/Edit`, bodyObject);
    },

    DeleteCities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Cities/Delete`);
    },

    ChangeStatusCities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Cities/ChangeStatus`);
    },





    // AcademicLevelsOld
    GetAcademicLevelsOld(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/AcademicLevelsOld/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllAcademicLevelsOld() {
        return axios.get(`api/admin/Dictionaries/AcademicLevelsOld/GetAll`);
    },

    AddAcademicLevelsOld(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicLevelsOld/Add`, bodyObject);
    },

    EditAcademicLevelsOld(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicLevelsOld/Edit`, bodyObject);
    },

    DeleteAcademicLevelsOld(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicLevelsOld/Delete`);
    },

    ChangeStatusAcademicLevelsOld(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicLevelsOld/ChangeStatus`);
    },





    // AcademicSpecializationsOld
    GetAcademicSpecializationsOld(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializationsOld/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    GetAllAcademicSpecializationsOld(Id) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializationsOld/GetAll?AcademicLevelId=${Id}`);
    },

    AddAcademicSpecializationsOld(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicSpecializationsOld/Add`, bodyObject);
    },

    EditAcademicSpecializationsOld(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicSpecializationsOld/Edit`, bodyObject);
    },

    DeleteAcademicSpecializationsOld(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicSpecializationsOld/Delete`);
    },

    ChangeStatusAcademicSpecializationsOld(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicSpecializationsOld/ChangeStatus`);
    },




    // AcademicSpecializations
    GetAcademicSpecializations(pageNo, pageSize, Search, AcademicSpecializationsId) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializations/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&AcademicSpecializationsId=${AcademicSpecializationsId}`);
    },

    GetAcademicSpecializationsChild(pageNo, pageSize, Search, AcademicSpecializationsId) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializations/GetChild?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}&AcademicSpecializationsId=${AcademicSpecializationsId}`);
    },

    GetAllAcademicSpecializations(Id) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializations/GetAll?AcademicSpecializationsId=${Id}`);
    },

    GetAcademicSpecializationPath(parentId) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializations/GetPath?id=${parentId}`);
    },

    AddAcademicSpecializations(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicSpecializations/Add`, bodyObject);
    },

    EditAcademicSpecializations(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicSpecializations/Edit`, bodyObject);
    },

    DeleteAcademicSpecializations(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicSpecializations/Delete`);
    },

    ChangeStatusAcademicSpecializations(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicSpecializations/ChangeStatus`);
    },








    // Faq
    GetFaq(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Faq/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    DeleteFaq(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Faq/Delete`);
    },

    ChangeStatusFaq(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Faq/ChangeStatus`);
    },


    // Notifications
    GetNotifications(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Notifications/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    PushNotifications(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Notifications/Push`, bodyObject);
    },




    GetDashboardInfo() {
        return axios.get(`api/admin/Dictionaries/Dashboard/Get`);
    },



    // ********************************| End Dictionaries |********************************
























    // ********************************| Courses |************************************

    GetCourses(pageNo, pageSize, Search, IsFree, IsDiscount, SalesStatus, ViewStatus) {
        return axios.get(`api/admin/Courses/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &IsFree=${IsFree}&IsDiscount=${IsDiscount}&SalesStatus=${SalesStatus}&Status=${ViewStatus}`);
    },

    GetAllCourses(AcademicSpecializationId) {
        return axios.get(`api/admin/Courses/GetAll?AcademicSpecializationId=${AcademicSpecializationId}`);
    },

    GetAllCoursesName() {
        return axios.get(`api/admin/Courses/GetNames`);
    },

    GetAllCoursesBySubjectSpecialization(SubjectId, AcademicSpecializationId) {
        return axios.get(`api/admin/Courses/GetBySubjectSpecialization?SubjectId=${SubjectId}&AcademicSpecializationId=${AcademicSpecializationId}`);
    },

    AddCourses(bodyObject) {
        return axios.post(`api/admin/Courses/Add`, bodyObject);
    },

    EditCourses(bodyObject) {
        return axios.post(`api/admin/Courses/Edit`, bodyObject);
    },

    DeleteCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Delete`);
    },

    ChangeStatusCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/ChangeStatus`);
    },

    ChangeSalesStatusCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/ChangeSalesStatus`);
    },

    CloseCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Close`);
    },

    AddTransferCoursesCourses(bodyObject) {
        return axios.post(`api/admin/Courses/TransferCourses`, bodyObject);
    },

    AddTransferCoursesShapter(bodyObject) {
        return axios.post(`api/admin/Courses/Shapters/Transfer`, bodyObject);
    },




    //Closed Course
    GetClosedCourses(pageNo, pageSize, Search, IsFree, IsDiscount) {
        return axios.get(`api/admin/Courses/GetClosed?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &IsFree=${IsFree}&IsDiscount=${IsDiscount}`);
    },

    OpenCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Open`);
    },


    //ChartInfo
    GetAllCoursesChartInfo() {
        return axios.get(`api/admin/Courses/Chart/GetAll`);
    },


    //ChartInfo
    GetCoursesChartInfo(Id) {
        return axios.get(`api/admin/Courses/Chart/Get?Id=${Id}`);
    },








    //Shapters
    GetCourseShapters(Id, Search) {
        return axios.get(`api/admin/Courses/Shapters/Get?Id=${Id}&Search=${Search}`);
    },

    GetAllShapters(Id) {
        return axios.get(`api/admin/Courses/Shapters/GetAll?CourseId=${Id}`);
    },

    AddShapters(bodyObject) {
        return axios.post(`api/admin/Courses/Shapters/Add`, bodyObject);
    },

    EditShapters(bodyObject) {
        return axios.post(`api/admin/Courses/Shapters/Edit`, bodyObject);
    },

    DeleteShapters(Id) {
        return axios.post(`api/admin/Courses/${Id}/Shapters/Delete`);
    },

    ChangeStatusShapters(Id) {
        return axios.post(`api/admin/Courses/${Id}/Shapters/ChangeStatus`);
    },






    //Lectures
    GetCourseLectures(CourseId, ShapterId, Search) {
        return axios.get(`api/admin/Courses/Lectures/Get?CourseId=${CourseId}&ShapterId=${ShapterId}&Search=${Search}`);
    },

    AddLectures(bodyObject) {
        return axios.post(`api/admin/Courses/Lectures/Add`, bodyObject);
    },

    EditLectures(bodyObject) {
        return axios.post(`api/admin/Courses/Lectures/Edit`, bodyObject);
    },

    DeleteLectures(Id) {
        return axios.post(`api/admin/Courses/${Id}/Lectures/Delete`);
    },

    ChangeStatusLectures(Id) {
        return axios.post(`api/admin/Courses/${Id}/Lectures/ChangeStatus`);
    },






    //LecturesAttashments
    GetCourseLecturesAttashments(LectureId, Search) {
        return axios.get(`api/admin/Courses/LecturesAttashments/Get?LectureId=${LectureId}&Search=${Search}`);
    },

    AddLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Add`, bodyObject);
    },

    EditLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Edit`, bodyObject);
    },

    DeleteLecturesAttashments(Id) {
        return axios.post(`api/admin/Courses/${Id}/LecturesAttashments/Delete`);
    },

    ChangeStatusLecturesAttashments(Id) {
        return axios.post(`api/admin/Courses/${Id}/LecturesAttashments/ChangeStatus`);
    },

    ReorderLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Reorder`, bodyObject);
    },


    //LecturesAttashments Vdocipher

    AddLecturesVdocipher(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Vdocipher/Add`, bodyObject);
    },

    EditLecturesVdocipher(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Vdocipher/Edit`, bodyObject);
    },

    GetCourseLecturesAttashmentsShowVideo(Id) {
        return axios.get(`api/admin/Courses/LecturesAttashments/Vdocipher/ShowVideo?Id=${Id}`);
    },







    //Exams
    GetCourseExams(CourseId, ShapterId, Search) {
        return axios.get(`api/admin/Courses/Exams/Get?CourseId=${CourseId}&ShapterId=${ShapterId}&Search=${Search}`);
    },

    AddExams(bodyObject) {
        return axios.post(`api/admin/Courses/Exams/Add`, bodyObject);
    },

    EditExams(bodyObject) {
        return axios.post(`api/admin/Courses/Exams/Edit`, bodyObject);
    },

    DeleteExams(Id) {
        return axios.post(`api/admin/Courses/${Id}/Exams/Delete`);
    },

    ChangeStatusExams(Id) {
        return axios.post(`api/admin/Courses/${Id}/Exams/ChangeStatus`);
    },






    //ExamsQuestions
    GetCourseExamsQuestions(ExamId, Search) {
        return axios.get(`api/admin/Courses/ExamsQuestions/Get?ExamId=${ExamId}&Search=${Search}`);
    },

    AddExamsQuestions(bodyObject) {
        return axios.post(`api/admin/Courses/ExamsQuestions/Add`, bodyObject);
    },

    EditExamsQuestions(bodyObject) {
        return axios.post(`api/admin/Courses/ExamsQuestions/Edit`, bodyObject);
    },

    DeleteExamsQuestions(Id) {
        return axios.post(`api/admin/Courses/${Id}/ExamsQuestions/Delete`);
    },

    ChangeStatusExamsQuestions(Id) {
        return axios.post(`api/admin/Courses/${Id}/ExamsQuestions/ChangeStatus`);
    },


    //Students
    GetCourseStudents(Id, Search) {
        return axios.get(`api/admin/Courses/Students/Get?Id=${Id}&Search=${Search}`);
    },


    //Review
    GetCourseReview(Id, Search) {
        return axios.get(`api/admin/Courses/Review/Get?Id=${Id}&Search=${Search}`);
    },

    //// ********************************| Question Banks |********************************

    GetQuestionBanks(pageNo, pageSize, Search, IsFree, IsDiscount, SalesStatus, Status) {
        return axios.get(`api/admin/QuestionBanks/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&IsFree=${IsFree}&IsDiscount=${IsDiscount}&SalesStatus=${SalesStatus}&Status=${Status}`);
    },

    AddQuestionBanks(bodyObject) {
        return axios.post(`api/admin/QuestionBanks/Add`, bodyObject);
    },

    EditQuestionBanks(bodyObject) {
        return axios.post(`api/admin/QuestionBanks/Edit`, bodyObject);
    },

    DeleteQuestionBanks(Id) {
        return axios.post(`api/admin/QuestionBanks/${Id}/Delete`);
    },

    ChangeSalesStatusQuestionBanks(Id) {
        return axios.post(`api/admin/QuestionBanks/${Id}/ChangeSalesStatus`);
    },

    ChangeStatusQuestionBanks(Id) {
        return axios.post(`api/admin/QuestionBanks/${Id}/ChangeStatus`);
    },

    GetQuestionBankShapters(QuestionBankId, Search) {
        return axios.get(`api/admin/QuestionBanks/Shapters/Get?QuestionBankId=${QuestionBankId}&Search=${Search || ''}`);
    },

    AddQuestionBankShapters(bodyObject) {
        return axios.post(`api/admin/QuestionBanks/Shapters/Add`, bodyObject);
    },

    EditQuestionBankShapters(bodyObject) {
        return axios.post(`api/admin/QuestionBanks/Shapters/Edit`, bodyObject);
    },

    DeleteQuestionBankShapters(Id) {
        return axios.post(`api/admin/QuestionBanks/${Id}/Shapters/Delete`);
    },

    ChangeStatusQuestionBankShapters(Id) {
        return axios.post(`api/admin/QuestionBanks/Shapters/${Id}/ChangeStatus`);
    },

    GetQuestionBankItems(ShapterId) {
        return axios.get(`api/admin/QuestionBanks/Items/Get?ShapterId=${ShapterId}`);
    },

    AddQuestionBankItems(bodyObject) {
        return axios.post(`api/admin/QuestionBanks/Items/Add`, bodyObject);
    },

    EditQuestionBankItems(bodyObject) {
        return axios.post(`api/admin/QuestionBanks/Items/Edit`, bodyObject);
    },

    DeleteQuestionBankItems(Id) {
        return axios.post(`api/admin/QuestionBanks/${Id}/Items/Delete`);
    },

    GetQuestionBankQuestions(ItemId) {
        return axios.get(`api/admin/QuestionBanks/Questions/Get?ItemId=${ItemId}`);
    },

    AddQuestionBankQuestions(bodyObject) {
        return axios.post(`api/admin/QuestionBanks/Questions/Add`, bodyObject);
    },

    EditQuestionBankQuestions(bodyObject) {
        return axios.post(`api/admin/QuestionBanks/Questions/Edit`, bodyObject);
    },

    DeleteQuestionBankQuestions(Id) {
        return axios.post(`api/admin/QuestionBanks/${Id}/Questions/Delete`);
    },

    GetQuestionBankStudents(QuestionBankId, Search) {
        return axios.get(`api/admin/QuestionBanks/Students/Get?QuestionBankId=${QuestionBankId}&Search=${Search || ''}`);
    },

    //// ********************************| End Courses |********************************















    //// ********************************| Students |********************************


    GetStudents(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllStudents() {
        return axios.get(`api/admin/Students/GetAll`);
    },

    AddStudents(bodyObject) {
        return axios.post(`api/admin/Students/Add`, bodyObject);
    },

    EditStudents(bodyObject) {
        return axios.post(`api/admin/Students/Edit`, bodyObject);
    },

    ChangeStatusStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeStatus`);
    },

    ResetDeviceStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ResetDevice`);
    },

    ResetPasswordStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ResetPassword`);
    },

    DeleteStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/Delete`);
    },

    //Suspends
    SuspendsStudents(bodyObject) {
        return axios.post(`api/admin/Students/Suspends/Add`, bodyObject);
    },

    GetSuspendsStudents(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/Suspends/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    CanselSuspends(Id) {
        return axios.post(`api/admin/Students/${Id}/Suspends/Cansel`);
    },





    //ChangeRequest
    GetChangeRequest(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/ChangeRequest/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AcceptChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Accept`);
    },

    AcceptAllChangeRequest() {
        return axios.post(`api/admin/Students/ChangeRequest/AcceptAll`);
    },

    RejectChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Reject`);
    },

    DeleteChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Delete`);
    },

    DeleteAllChangeRequest() {
        return axios.post(`api/admin/Students/ChangeRequest/DeleteAll`);
    },





    //CoursesRequests
    GetCoursesRequests(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/CoursesRequests/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AcceptCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Accept`);
    },

    RejectCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Reject`);
    },

    DeleteCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Delete`);
    },









    //Studetns Courses
    GetStudentsCourses(Id, Search) {
        return axios.get(`api/admin/Students/Courses/Get?Id=${Id}&Search=${Search}`);
    },

    AddStudentsCourses(bodyObject) {
        return axios.post(`api/admin/Students/Courses/Add`, bodyObject);
    },

    AddStudentsCoursesValue(bodyObject) {
        return axios.post(`api/admin/Students/Courses/AddValue`, bodyObject);
    },

    DropStudentsCourses(bodyObject) {
        return axios.post(`api/admin/Students/Courses/Drop`, bodyObject);
    },

    GetStudentsQuestionBanks(Id, Search) {
        return axios.get(`api/admin/Students/QuestionBanks/Get?Id=${Id}&Search=${Search}`);
    },

    AddStudentsQuestionBanks(bodyObject) {
        return axios.post(`api/admin/Students/QuestionBanks/Add`, bodyObject);
    },

    AddStudentsQuestionBanksValue(bodyObject) {
        return axios.post(`api/admin/Students/QuestionBanks/AddValue`, bodyObject);
    },

    DropStudentsQuestionBanks(bodyObject) {
        return axios.post(`api/admin/Students/QuestionBanks/Drop`, bodyObject);
    },

    GetAllQuestionBanksBySubjectSpecialization(SubjectId, AcademicSpecializationId) {
        return axios.get(`api/admin/QuestionBanks/GetBySubjectSpecialization?SubjectId=${SubjectId}&AcademicSpecializationId=${AcademicSpecializationId}`);
    },







    //Wallet
    GetStudentsWallet(Id) {
        return axios.get(`api/admin/Students/Wallet/Get?Id=${Id}`);
    },

    AddStudentsWalletValue(bodyObject) {
        return axios.post(`api/admin/Students/Wallet/Charge`, bodyObject);
    },

    ChargeStudentsGift(bodyObject) {
        return axios.post(`api/admin/Gift/Charge`, bodyObject);
    },

    ChargeStudentsGiftAll(bodyObject) {
        return axios.post(`api/admin/Gift/ChargeAll`, bodyObject);
    },

    GetGiftActiveCount() {
        return axios.get(`api/admin/Gift/ActiveCount`);
    },

    GetGiftSummary(From, To) {
        return axios.get(`api/admin/Gift/Summary?From=${From || ''}&To=${To || ''}`);
    },

    GetGiftCharges(pageNo, pageSize, Search, From, To) {
        return axios.get(`api/admin/Gift/Charges?pageNo=${pageNo}&pageSize=${pageSize}&Search=${Search || ''}&From=${From || ''}&To=${To || ''}`);
    },

    GetGiftPurchases(pageNo, pageSize, Search, From, To) {
        return axios.get(`api/admin/Gift/Purchases?pageNo=${pageNo}&pageSize=${pageSize}&Search=${Search || ''}&From=${From || ''}&To=${To || ''}`);
    },

    GetGiftBalances(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Gift/Balances?pageNo=${pageNo}&pageSize=${pageSize}&Search=${Search || ''}`);
    },






    //Devices
    GetStudentsDevices(Id) {
        return axios.get(`api/admin/Students/Devices/Get?Id=${Id}`);
    },

    ChangeStudentsDeviceStatus(deviceId) {
        return axios.post(`api/admin/Students/Devices/${deviceId}/ChangeStatus`);
    },


    GetAllStudentsChartInfo() {
        return axios.get(`api/admin/Students/Chart/GetAll`);
    },



    //// ********************************| End Of Students |********************************













    // ********************************| Instructors |********************************



    GetInstructors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Instructors/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllInstructors() {
        return axios.get(`api/admin/Instructors/GetAll`);
    },

    AddInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Add`, bodyObject);
    },

    EditInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Edit`, bodyObject);
    },

    ChangeStatusInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ChangeStatus`);
    },

    ResetDeviceInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ResetDevice`);
    },

    ResetPasswordInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ResetPassword`);
    },

    DeleteInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/Delete`);
    },

    //Financials
    PayInstructorsFinancials(bodyObject) {
        return axios.post(`api/admin/Instructors/Financials/Pay`, bodyObject);
    },

    GetInstructorsFinancials(Id) {
        return axios.get(`api/admin/Instructors/Financials/Get?Id=${Id}`);
    },

    DeleteInstructorsFinancials(Id) {
        return axios.post(`api/admin/Instructors/${Id}/Financials/Delete`);
    },




    //Suspends
    SuspendsInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Suspends/Add`, bodyObject);
    },

    GetSuspendsInstructors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Instructors/Suspends/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    CanselInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/Suspends/Cansel`);
    },



    // ********************************| End Of Instructors |********************************












    // ********************************| Financial |********************************

    GetSubscriptions(pageNo, pageSize, Search, From, To) {
        return axios.get(`api/admin/Financial/GetSubscriptions?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}`);
    },

    GetRecharge(pageNo, pageSize, Search, From, To, UserId, DistributorsId, PaymentMethodId) {
        return axios.get(`api/admin/Financial/GetRecharge?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&UserId=${UserId}&DistributorsId=${DistributorsId}&PaymentMethodId=${PaymentMethodId}`);
    },

    GetWalletTracker(pageNo, pageSize, Search, From, To, ProcessType, Channel) {
        return axios.get(`api/admin/Financial/GetWalletTracker?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&ProcessType=${ProcessType}&Channel=${Channel}`);
    },


    GetWithdrawingTracker(pageNo, pageSize, Search, From, To, PaymentMethodId, WithdrawingId, Operation, instructorUserId) {
        const uid = instructorUserId != null && instructorUserId !== '' ? instructorUserId : 0;
        return axios.get(`api/admin/Financial/GetWithdrawingTracker?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&PaymentMethodId=${PaymentMethodId}&WithdrawingId=${WithdrawingId}&Operation=${Operation}&UserId=${uid}`);
    },

    GetTlyncPayments(pageNo, pageSize, Search, From, To, Level) {
        return axios.get(`api/admin/Financial/GetTlyncPayments?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&Level=${Level}`);
    },

    GetEzonePayPayments(pageNo, pageSize, Search, From, To, Level) {
        return axios.get(`api/admin/Financial/GetEzonePayPayments?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&Level=${Level}`);
    },





    // ********************************| End Of Financial |********************************














    // ********************************| VoucherCards |********************************

    GetVoucherCards(pageNo, pageSize, Search, DistributorsId) {
        return axios.get(`api/admin/VoucherCards/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}&DistributorsId=${DistributorsId}`);
    },

    AddVoucherCards(bodyObject) {
        return axios.post('api/admin/VoucherCards/Add', bodyObject);
    },

    SaleVoucherCards(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Sale`, { responseType: 'blob' });
    },

    ForzePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Freeze`, { responseType: 'blob' });
    },

    DeletePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Delete`);
    },



    //Card
    GetCards() {
        return axios.get(`api/admin/VoucherCards/Cards/Get`);
    },

    GetCardInfoBySerialNumber(SerialNumber) {
        return axios.get(`api/admin/VoucherCards/Cards/GetCardInfoBySerialNumber?SerialNumber=${SerialNumber}`);
    },

    GetCardInfoByVoucherNumber(VoucherNumber) {
        return axios.get(`api/admin/VoucherCards/Cards/GetCardInfoByVoucherNumber?SerialNumber=${VoucherNumber}`);
    },


    //TryAttemp
    GetVoucherCardsTryAttemp(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/TryAttemp/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },



    //Chart
    GetVoucherCardsChart() {
        return axios.get(`api/admin/VoucherCards/Chart/Get`);
    },






    //Distributors
    GetDistributors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/Distributors/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllDistributors() {
        return axios.get(`api/admin/VoucherCards/Distributors/GetAll`);
    },

    AddDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/Add', bodyObject);
    },

    EditDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/Edit', bodyObject);
    },

    ResetPasswordDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/ResetPassword`);
    },

    ChangeStatusDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/ChangeStatus`);
    },

    DeleteDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/Delete`);
    },




    ActivePackgeDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/ActivePackge', bodyObject);
    },

    GetDistributorsPackages(pageNo, pageSize) {
        return axios.get(`api/admin/VoucherCards/Distributors/Packages/Get?pageNo=${pageNo}&pagesize=${pageSize}`);
    },

    // ********************************| End Of VoucherCards |********************************












    // ********************************| Users |********************************
    GetUsers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Users/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetUsersTransactions(pageNoT, pageSizeT, Id) {
        return axios.get(`api/admin/Users/GetTransactions?pageNo=${pageNoT}&pagesize=${pageSizeT}&Id=${Id}`);
    },

    GetAllUsers() {
        return axios.get(`api/admin/Users/GetAll`);
    },

    AddUsers(bodyObject) {
        console.log("sdsdsdsds", bodyObject);
        return axios.post('api/admin/Users/Add', bodyObject);
    },

    EditUsers(bodyObject) {
        return axios.post('api/admin/Users/Edit', bodyObject);
    },

    ResetPasswordUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ResetPassword`);
    },

    ChangeStatusUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ChangeStatus`);
    },

    DeleteUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/Delete`);
    },


    //USerProfile 
    ChangeProfilePicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePicture', bodyObject);
    },

    ChangeProfileInfo(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangeInfo', bodyObject);
    },

    ChangeProfilePassword(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePassword', bodyObject);
    },





    //Financials
    PayUsersFinancials(bodyObject) {
        return axios.post(`api/admin/Users/Financials/Pay`, bodyObject);
    },

    GetUsersFinancials(Id) {
        return axios.get(`api/admin/Users/Financials/Get?Id=${Id}`);
    },

    DeleteUsersFinancials(Id) {
        return axios.post(`api/admin/Users/${Id}/Financials/Delete`);
    },


    // ********************************| End Of Users |********************************

    //**********************************| Room |***************************
    GetRooms(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Room?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllRooms() {
        return axios.get(`api/admin/Dictionaries/Room/All`);
    },
    GetById(id) {
        return axios.get(`api/admin/Dictionaries/Room/${id}`);
    },

    AddRoom(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Room`, bodyObject);
    },

    EditRoom(bodyObject) {
        return axios.put(`api/admin/Dictionaries/Room`, bodyObject);
    },

    DeleteRoom(Id) {
        return axios.delete(`api/admin/Dictionaries/Room/${Id}`);
    },
    ChangeStatus(Id) {
        return axios.put(`api/admin/Dictionaries/Room/ChangeStatus/${Id}`);
    },


    //**********************************| RoomSchedule |***************************
    GetRoomSchedules(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/RoomSchedule?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllRoomsSchedule() {
        return axios.get(`api/admin/Dictionaries/RoomSchedule/All`);
    },
    GetScheduleById(id) {
        return axios.get(`api/admin/Dictionaries/RoomSchedule/${id}`);
    },

    AddRoomSchedule(bodyObject) {
        return axios.post(`api/admin/Dictionaries/RoomSchedule`, bodyObject);
    },

    EditRoomSchedule(bodyObject) {
        return axios.put(`api/admin/Dictionaries/RoomSchedule`, bodyObject);
    },

    DeleteRoomSchedule(Id) {
        return axios.delete(`api/admin/Dictionaries/RoomSchedule/${Id}`);
    },
    ChangeStatusRoomSchedule(Id) {
        return axios.put(`api/admin/Dictionaries/RoomSchedule/ChangeStatus/${Id}`);
    },
    GetSchedulesByRoom(Id) {
        return axios.get(`api/admin/Dictionaries/RoomSchedule/ByRoom/${Id}`);
    },
    GetSchedulesByRoomDay(Id, Day) {
        return axios.get(`api/admin/Instructors/RoomSchedule/ByRoom/${Id}/${Day}`);
    },

    //**********************************| Bookings |***************************
    GetBookings(pageNo, pageSize, Search, roomId, scheduleId, status, date) {
        return axios.get(`api/admin/Dictionaries/Booking?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&roomId=${roomId}&scheduleId=${scheduleId}&status=${status}&date=${date}`);
    },

    GetBookingsInstructors(pageNo, pageSize,) {
        return axios.get(`api/admin/Instructors/Booking?pageno=${pageNo}&pagesize=${pageSize}`);
    },
    CheckBookingAvailability(RoomScheduleId, BookingDate, Id) {
        return axios.get(`api/admin/Dictionaries/Booking/CheckAvailability?scheduleId=${RoomScheduleId}&date=${BookingDate}&excludeBookingId=${Id}`);
    },

    AddBooking(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Booking`, bodyObject);
    },
    AddBookingInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Booking`, bodyObject);
    },

    EditBooking(bodyObject) {
        return axios.put(`api/admin/Dictionaries/Booking`, bodyObject);
    },

    DeleteBooking(Id) {
        return axios.delete(`api/admin/Dictionaries/Booking/${Id}`);
    },
    CancelBooking(Id) {
        return axios.put(`api/admin/Dictionaries/Booking/Cancel/${Id}`);
    },

    //**********************************| Coupons |***************************
    GetCoupons(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Coupons/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AddCoupons(bodyObject) {
        console.log("ssss", bodyObject)
        return axios.post(`api/admin/Coupons/Add`, bodyObject);
    },

    EditCoupons(bodyObject) {
        return axios.post(`api/admin/Coupons/Edit`, bodyObject);
    },

    DeleteCoupons(Id) {
        return axios.post(`api/admin/Coupons/${Id}/Delete`);
    },

    ChangeStatusCoupons(Id) {
        return axios.post(`api/admin/Coupons/${Id}/ChangeStatus`);
    },


    // Support Chat
    GetSupportTickets(pageNo, pageSize, status) {
        const statusQuery = status ? `&status=${status}` : '';
        return axios.get(`api/admin/SupportChat/Tickets?pageNo=${pageNo}&pageSize=${pageSize}${statusQuery}`);
    },

    GetSupportMessages(roomId, pageNo, pageSize, beforeId) {
        const beforeQuery = beforeId ? `&beforeId=${beforeId}` : '';
        return axios.get(`api/admin/SupportChat/Tickets/${roomId}/Messages?pageNo=${pageNo}&pageSize=${pageSize}${beforeQuery}`);
    },

    ReplySupportTicket(roomId, body) {
        return axios.post(`api/admin/SupportChat/Tickets/${roomId}/Reply`, body);
    },

    CloseSupportTicket(ticketId) {
        return axios.post(`api/admin/SupportChat/Tickets/${ticketId}/Close`);
    },

    GetSupportUnreadCount() {
        return axios.get(`api/admin/SupportChat/UnreadCount`);
    },

    AiGenerateExamQuestions(bodyObject) {
        return axios.post(`api/admin/Ai/GenerateExamQuestions`, bodyObject);
    },

    AiSaveExamQuestions(bodyObject) {
        return axios.post(`api/admin/Ai/SaveExamQuestions`, bodyObject);
    },

    AiReindexCourse(bodyObject) {
        return axios.post(`api/admin/Ai/ReindexCourse`, bodyObject);
    },

    AiGetCourseIndexStatus(courseId) {
        return axios.get(`api/admin/Ai/CourseIndexStatus?courseId=${courseId}`);
    },
}
